import { G__Spinner as g__spinner } from './g--spinner/directive';

export const General = {
    directives: {
        g__spinner
    },
    modules: {}
};
